export default __webpack_public_path__ + "static/4_33-b289cadbc825c4724019f200c96ca4d2.png";